import api from "./client";

export function getFacilitySettings() {
  return api.get("/admin/facility-settings");
}

export function updateFacilitySettings(data) {
  return api.put("/admin/facility-settings", data);
}
